<template>
  <div id="home" class="">
    <div class="grid px-3 md:px-0 md:grid-cols-2 md:gap-4">
      <div class="">
        <h2 class="mb-2 text-lg text-indigo-500">Original HTML (Paste here)</h2>
        <Codemirror
          v-model:value="html"
          :options="editorOptions"
          border
          placeholder="Paste html here"
          class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden mb-3"
          :height="600" />
        <div>
          <button @click="insertSample" class="px-4 py-2 font-semibold text-sm bg-cyan-500 text-white rounded-none shadow-sm">Try it!</button>
          <button @click="clear" class="ml-2 px-4 py-2 font-semibold text-sm bg-cyan-500 text-white rounded-none shadow-sm">Clear</button>
        </div>
      </div>
      <div class="innerHtml">
        <h2 class="mb-2 text-lg text-indigo-500 mt-4 sm:mt-0">Stripped HTML</h2>
        <Codemirror
          ref="strippedHtmlWindow"
          v-model:value="strippedHtml"
          :options="strippedOptions"
          border
          readonly="true"
          class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden mb-3"
          :height="600" />
          <div class="flex gap-5 items-center">
            <div class="">
              <button @click="copyToClipboard" class="px-4 py-2 font-semibold text-sm bg-cyan-500 text-white rounded-none shadow-sm">{{ buttons.copy.text }}</button>
            </div>
            <div class="">
              <label class="flex items-center ">
                <input type="checkbox" class="form-checkbox" v-model="optimizeHtml">
                <span class="ml-2">Optimize Html</span>
              </label>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */

import { parse } from 'node-html-parser';
import Codemirror from "codemirror-editor-vue3";
import "codemirror/mode/htmlmixed/htmlmixed.js";
var beautify = require('js-beautify').html;


export default {
  name: 'HomePage',
  props: {
    
  },
  components: {
    Codemirror 
  },
  data: function () {
    return {
      isDev:  process.env.NODE_ENV == "development",
      html: ``,
      strippedHtml: ``, 
      optimizeHtml: true,
      editorOptions: {
        mode: "htmlmixed", // Language mode
        lineNumbers: true, // Show line number
        smartIndent: true, // Smart indent
        indentUnit: 2, // The smart indent unit is 2 spaces in length
        styleActiveLine: true, // Display the style of the selected row
      },
      strippedOptions: {
        mode: "htmlmixed", // Language mode
        lineNumbers: true, // Show line number
        smartIndent: true, // Smart indent
        indentUnit: 2, // The smart indent unit is 2 spaces in length
        readOnly: 'nocursor',
        styleActiveLine: true, // Display the style of the selected row
      },
      buttons: {
        copy: {
          text: "",
          default: "Copy to clipboard",
          action: "Copied!"
        }
      }
    }
  },
  mounted: function() {
    this.buttons.copy.text = this.buttons.copy.default;
  },
  methods: {
    copyToClipboard: function(){
      var $that = this;
      this.$copyText(this.strippedHtml, undefined, function(){
        $that.buttons.copy.text = $that.buttons.copy.action;

        setTimeout(function(){
          $that.buttons.copy.text = $that.buttons.copy.default;
        }, 2000);
      });
    },
    formatHtml: function(){
      var root = parse(this.html);

      console.log("Parsing Html");

      root.querySelectorAll("[class]" ).forEach(function(el) {
        el.removeAttribute("class");
      });

      if(this.optimizeHtml){
        console.log("Optimizing Html");
        
        //Bubble up empty divs
        root.querySelectorAll("div").filter(x => x.parentNode != null).forEach(function(el) {
          if(el.childNodes.length > 0){
            var mainNodes = el.childNodes.filter(x => x.nodeType === 1);
            var divNodes = mainNodes.filter(x => x.rawTagName === "div");
            
            if(mainNodes.length == divNodes.length){
              var children = el.childNodes;

              if(el.parentNode.parentNode != null){
                children.forEach(function(child, index){
                  var newItem = child.clone();
                  el.parentNode.appendChild(newItem, el);
                });

                //Remove the empty node;
                el.remove();
              }
            }
          }
          //Remove empty nodes
          else if(el.childNodes.length === 0){
            el.parentNode.removeChild(el);
          }
        });

        //Remove completely empty nodes
        root.querySelectorAll("div").filter(x => x.childNodes.length == 0).forEach(function(el) {
            el.parentNode.removeChild(el);
        });
      }

      this.strippedHtml = root.toString();

      //Remove the newlines
      this.strippedHtml = beautify(this.strippedHtml, 
                                { 
                                  "preserve_newlines": false,
                                  "indent_empty_lines": false
                                }
                              );
    },
    clear: function(){
      this.html = ``;
    },
    insertSample: function(){
      var samples = [];
      
      samples.push(`<div class="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
  <div>
    <div></div>
  </div>
  <div class="max-w-max mx-auto">
    <main class="sm:flex">
      <p class="text-4xl font-extrabold text-indigo-600 sm:text-5xl">404</p>
      <div class="sm:ml-6">
        <div class="sm:border-l sm:border-gray-200 sm:pl-6">
          <h1 class="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">Page not found</h1>
          <p class="mt-1 text-base text-gray-500">Please check the URL in the address bar and try again.</p>
        </div>
        <div class="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
          <a href="#" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"> Go back home </a>
          <a href="#" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"> Contact support </a>
        </div>
      </div>
    </main>
  </div>
  <div></div>
</div>`);

samples.push(` <div id="root" class="relative bg-gray-50 overflow-hidden">
    <div id="svg-section" class="hidden sm:block sm:absolute sm:inset-y-0 sm:h-full sm:w-full" aria-hidden="true">
      <div  id="svg-section-child" class="relative h-full max-w-7xl mx-auto">
        <svg class="absolute right-full transform translate-y-1/4 translate-x-1/4 lg:translate-x-1/2" width="404" height="784" fill="none" viewBox="0 0 404 784">
          <rect width="404" height="784" fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
        </svg>
        <svg class="absolute left-full transform -translate-y-3/4 -translate-x-1/4 md:-translate-y-1/2 lg:-translate-x-1/2" width="404" height="784" fill="none" viewBox="0 0 404 784">
          <rect width="404" height="784" fill="url(#5d0dd344-b041-4d26-bec4-8d33ea57ec9b)" />
        </svg>
      </div>
    </div>

    <div id="popover-section"  class="relative pt-6 pb-16 sm:pb-24">
      <Popover>
        <div class="max-w-7xl mx-auto px-4 sm:px-6">
          <nav class="relative flex items-center justify-between sm:h-10 md:justify-center" aria-label="Global">
            <div class="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0">
              <div class="flex items-center justify-between w-full md:w-auto">
                <a href="#">
                  <span class="sr-only">Workflow</span>
                  <img class="h-8 w-auto sm:h-10" src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg" alt="" />
                </a>
                <div class="-mr-2 flex items-center md:hidden">
                  <PopoverButton class="bg-gray-50 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span class="sr-only">Open main menu</span>
                    <MenuIcon class="h-6 w-6" aria-hidden="true" />
                  </PopoverButton>
                </div>
              </div>
            </div>
            <div class="hidden md:flex md:space-x-10">
              <a v-for="item in navigation" :key="item.name" :href="item.href" class="font-medium text-gray-500 hover:text-gray-900">{{ item.name }}</a>
            </div>
            <div class="hidden md:absolute md:flex md:items-center md:justify-end md:inset-y-0 md:right-0">
              <span class="inline-flex rounded-md shadow">
                <a href="#" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50"> Log in </a>
              </span>
            </div>
          </nav>
        </div>
      </Popover>

      <main class="mt-16 mx-auto max-w-7xl px-4 sm:mt-24">
        <div class="text-center">
          <h1 class="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
            <span class="block text-indigo-600 xl:inline">online business</span>
          </h1>
          <p class="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat fugiat aliqua.</p>
          <div class="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
            <div class="rounded-md shadow">
              <a href="#" class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10"> Get started </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>`);

      this.html = samples[Math.round(Math.random())];

    }
  },
  watch: {
    optimizeHtml: function(val){
      console.log("Optimize change");
      this.formatHtml();
    },
    html: function (val) {
      this.formatHtml();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
